// @flow

import Service from './service';
import type { ApiConstructorArgsType } from '../types/api';

export default class TranslationService extends Service {
  constructor(args: ApiConstructorArgsType = {}) {
    super(args);
    this.baseUrl = this.conf.path.translateBase;
  }

  getTranslation({
    key,
    brand = 'stride',
    locale = 'en-US',
    isLocal,
    options,
  }: {
    key: string,
    brand: string,
    locale: string,
    isLocal: boolean,
    options?: Object,
  }): Promise<Object> {
    const url = isLocal ?
      `${this.baseUrl}/translations/${locale}/${key}.json` :
      `${this.baseUrl}/${brand}/translations/${locale}/${key}.json`;
    return this.api.get(url, options)
      .then(({ data }) => data);
  }
}
